import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DocumentEffects } from './document.effects';
import { reducer } from './document.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('document', reducer),
    EffectsModule.forFeature([DocumentEffects]),
  ],
  providers: [DocumentEffects],
})
export class DocumentStoreModule {}
